// src/AutoReconnectToggle.js
import React from "react";
import "./AutoReconnectToggle.css"; // We'll create this next

const AutoReconnectToggle = ({
  isEnabled,
  onToggle,
  disabled = false,
  tooltip = "",
}) => {
  return (
    <div
      className="auto-reconnect-toggle-container"
      title={disabled ? tooltip : ""}
    >
      <label
        htmlFor="auto-reconnect-toggle"
        className={`auto-reconnect-toggle-label ${disabled ? "disabled" : ""}`}
      >
        Auto-Reconnect WebSocket
        <input
          id="auto-reconnect-toggle"
          type="checkbox"
          checked={isEnabled}
          onChange={onToggle}
          className="auto-reconnect-toggle-checkbox"
          disabled={disabled}
        />
        <span className="auto-reconnect-toggle-slider"></span>
      </label>
    </div>
  );
};

export default AutoReconnectToggle;
